var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 527,
    height: 31,
    viewBox: "0 0 527 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 29.9001L36.1 0.100098H25.9L0 30.1001L10 29.9001Z",
    fill: "#FDE1B9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 19L17.4 0H7.29999L0.5 8V19Z",
    fill: "#FDE1B9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7002 29.7L54.7002 0H44.6002L18.7002 29.9L28.7002 29.7Z",
    fill: "#FDE1B9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4004 29.7L73.4004 0H63.3004L37.4004 29.9L47.4004 29.7Z",
    fill: "#FDE1B9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M66 29.7L92.1 0H81.9L56 29.9L66 29.7Z",
    fill: "#FDE1B9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7002 29.7L110.7 0H100.6L74.7002 29.9L84.7002 29.7Z",
    fill: "#FDE1B9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M103 29.7L129 0H118.9L93 29.9L103 29.7Z",
    fill: "#FDE1B9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M122 29.7L148 0H137.9L112 29.9L122 29.7Z",
    fill: "#FDE1B9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M140 29.7L166 0H155.9L130 29.9L140 29.7Z",
    fill: "#FDE1B9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M158 29.7L184 0H173.9L148 29.9L158 29.7Z",
    fill: "#FDE1B9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M178 29.7L204 0H193.9L168 29.9L178 29.7Z",
    fill: "#FDE1B9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M197 29.7L223 0H212.9L187 29.9L197 29.7Z",
    fill: "#FDE1B9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M216 29.7L242 0H231.9L206 29.9L216 29.7Z",
    fill: "#FDE1B9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M236 29.7L262 0H251.9L226 29.9L236 29.7Z",
    fill: "#FDE1B9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M255 29.7L281 0H270.9L245 29.9L255 29.7Z",
    fill: "#FDE1B9"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M275 29.7L283.1 19V9L265 29.9L275 29.7Z",
    fill: "#FDE1B9"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M293 29.9001L319.1 0.100098H308.9L283 30.1001L293 29.9001Z",
    fill: "#FDE1B9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M283.5 19L300.4 0H290.3L283.5 8V19Z",
    fill: "#FDE1B9"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M311.699 29.7L337.699 0H327.599L301.699 29.9L311.699 29.7Z",
    fill: "#FDE1B9"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M330.4 29.7L356.4 0H346.3L320.4 29.9L330.4 29.7Z",
    fill: "#FDE1B9"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M349 29.7L375.1 0H364.9L339 29.9L349 29.7Z",
    fill: "#FDE1B9"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M367.699 29.7L393.699 0H383.599L357.699 29.9L367.699 29.7Z",
    fill: "#FDE1B9"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M386 29.7L412 0H401.9L376 29.9L386 29.7Z",
    fill: "#FDE1B9"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M405 29.7L431 0H420.9L395 29.9L405 29.7Z",
    fill: "#FDE1B9"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M423 29.7L449 0H438.9L413 29.9L423 29.7Z",
    fill: "#FDE1B9"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M441 29.7L467 0H456.9L431 29.9L441 29.7Z",
    fill: "#FDE1B9"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M461 29.7L487 0H476.9L451 29.9L461 29.7Z",
    fill: "#FDE1B9"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M479 29.7L505 0H494.9L469 29.9L479 29.7Z",
    fill: "#FDE1B9"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M498 29.7L524 0H513.9L488 29.9L498 29.7Z",
    fill: "#FDE1B9"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M518 29.7L526.1 19V9L508 29.9L518 29.7Z",
    fill: "#FDE1B9"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVet);
export default __webpack_public_path__ + "static/media/vet.f9759fa3ab57b1203999451cc06dc4b1.svg";
export { ForwardRef as ReactComponent };